// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { ILevelProjectDto } from 'src/app/infrastructure/models/level-project-dto';
import { IProjectMemberData, projectMemberData } from 'src/app/features/project-member/models/project-member-data';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { IDomainUserDto } from './domain-user-dto.g';
import { IProjectDto } from './project-dto.g';
import { IDomainDto } from './domain-dto.g';
import { IUserDto } from './user-dto.g';
import { IImageBoxDto } from './image-box-dto.g';

export const projectMemberDto = {
    guid: 'guid',
    nr: 'nr',
    isAdmin: 'isAdmin',
    lastVisit: 'lastVisit',
    deleted: 'deleted',
    inactive: 'inactive',
    peerVisible: 'peerVisible',
    startDate: 'startDate',
    endDate: 'endDate',
    startDay: 'startDay',
    endDay: 'endDay',
    timeZoneId: 'timeZoneId',
    domainUserDto: 'domainUserDto',
    projectDto: 'projectDto',
    domainDto: 'domainDto',
    userDto: 'userDto',
    domainPhotoDto: 'domainPhotoDto',
    profilePhotoDto: 'profilePhotoDto',
    userPhotoDto: 'userPhotoDto',
} as const;

export type TProjectMemberDto = (typeof projectMemberDto)[keyof typeof projectMemberDto];

export const projectMemberDtoConstraints = {
} as const;

export type TProjectMemberDtoConstraints = typeof projectMemberDtoConstraints;

export interface IProjectMemberDto extends ILevelProjectDto {
    [projectMemberDto.guid]: string | null;
    [projectMemberDto.nr]: number | null;
    [projectMemberDto.isAdmin]: boolean | null;
    [projectMemberDto.lastVisit]: string | null;
    [projectMemberDto.deleted]: boolean | null;
    [projectMemberDto.inactive]: boolean | null;
    [projectMemberDto.peerVisible]: boolean | null;
    [projectMemberDto.startDate]: string | null;
    [projectMemberDto.endDate]: string | null;
    [projectMemberDto.startDay]: string | null;
    [projectMemberDto.endDay]: string | null;
    [projectMemberDto.timeZoneId]: string | null;
    [projectMemberDto.domainUserDto]: IDomainUserDto | null;
    [projectMemberDto.projectDto]: IProjectDto | null;
    [projectMemberDto.domainDto]: IDomainDto | null;
    [projectMemberDto.userDto]: IUserDto | null;
    [projectMemberDto.domainPhotoDto]: IImageBoxDto | null;
    [projectMemberDto.profilePhotoDto]: IImageBoxDto | null;
    [projectMemberDto.userPhotoDto]: IImageBoxDto | null;
}

export class ProjectMemberDto
    implements IProjectMemberDto
{
    [projectMemberDto.guid]: string | null = null;
    [projectMemberDto.nr]: number | null = null;
    [projectMemberDto.isAdmin]: boolean | null = null;
    [projectMemberDto.lastVisit]: string | null = null;
    [projectMemberDto.deleted]: boolean | null = null;
    [projectMemberDto.inactive]: boolean | null = null;
    [projectMemberDto.peerVisible]: boolean | null = null;
    [projectMemberDto.startDate]: string | null = null;
    [projectMemberDto.endDate]: string | null = null;
    [projectMemberDto.startDay]: string | null = null;
    [projectMemberDto.endDay]: string | null = null;
    [projectMemberDto.timeZoneId]: string | null = null;
    [projectMemberDto.domainUserDto]: IDomainUserDto | null = null;
    [projectMemberDto.projectDto]: IProjectDto | null = null;
    [projectMemberDto.domainDto]: IDomainDto | null = null;
    [projectMemberDto.userDto]: IUserDto | null = null;
    [projectMemberDto.domainPhotoDto]: IImageBoxDto | null = null;
    [projectMemberDto.profilePhotoDto]: IImageBoxDto | null = null;
    [projectMemberDto.userPhotoDto]: IImageBoxDto | null = null;

    private constructor(
        modelData?: IProjectMemberData
    ) {
        if (!modelData || isEmptyObject(modelData)) return;

        this[projectMemberDto.guid] = modelData[projectMemberData.guid];
        this[projectMemberDto.nr] = modelData[projectMemberData.nr];
        this[projectMemberDto.isAdmin] = modelData[projectMemberData.isAdmin];
        this[projectMemberDto.deleted] = modelData[projectMemberData.deleted];
        this[projectMemberDto.inactive] = modelData[projectMemberData.inactive];
    }

    static create(modelData?: IProjectMemberData | null): ProjectMemberDto | null {
        return modelData ? new ProjectMemberDto(modelData) : null;
    }
}
